export class PagerModel {
    public limit: number = 50;
    public nrOfResults: number = 0;
    public offset: number = 0;
    public orderBy: any = null;
    public ascending: boolean = true;
    public dateLimit?: string;

    constructor(pager?: PagerModel, nrOfResults?: number) {
        if (pager) {
            this.limit = pager.limit;
            this.nrOfResults = nrOfResults == undefined ? pager.nrOfResults : nrOfResults;
            this.offset = pager.offset;
            this.limit = pager.limit;
            this.orderBy = pager.orderBy;
            this.ascending = pager.ascending;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/list/PagerModel.ts